import React from 'react';
import './App.css';
import Carousel from './conponents/Carousel';

function App() {
  return (
    <div className='App'>
      <Carousel />
    </div>
  );
}

export default App;
